import { render } from "./carServerProtocol.vue?vue&type=template&id=3fc8ee52"
const script = {}

import "./carServerProtocol.vue?vue&type=style&index=0&id=3fc8ee52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__